import React from 'react';
import { TextFieldLabel } from 'ui-component-library';
import {
  string,
  func,
  bool,
  number,
} from 'prop-types';

import { CommentsCount, CommentsTextField } from './comments-box.style';

/**
 * The comment box component
 * @param {object} params - Object containing props
 * @param {string} params.comment - Comment value to display
 * @param {function} params.onCommentChanged - Function to handle when the comment changes
 * @param {string} params.placeholder - Placeholder text for the textarea
 * @param {boolean} params.error - Toggles if input is in error state
 * @param {number} params.characterLimit - Character limit
 * @param {boolean} params.showLabel - Toggle to show / hide label
 * @param {number} params.rows - Number of rows to show in the text field
 * @return {element} - CommentBox component
 */
const CommentBox = ({
  comment,
  onCommentChanged,
  placeholder,
  characterLimit,
  error,
  required,
  label,
  showLabel,
  rows,
}) => (
  <>
    {showLabel && <TextFieldLabel text={required ? `*${label}` : label} />}
    <CommentsTextField
      data-testid="comment-box"
      rows={rows}
      value={comment || ''}
      onChange={onCommentChanged}
      placeholder={placeholder}
      error={error}
    />
    <CommentsCount
      invalid={comment?.length > characterLimit}
    >
      {comment ? comment.length : 0}
      /
      {characterLimit}
    </CommentsCount>
  </>
);

CommentBox.propTypes = {
  comment: string,
  onCommentChanged: func,
  placeholder: string,
  error: bool,
  characterLimit: number,
  required: bool,
  label: string,
  showLabel: bool,
  rows: number,
};

CommentBox.defaultProps = {
  comment: null,
  onCommentChanged: () => { },
  placeholder: '',
  error: false,
  characterLimit: 500,
  required: false,
  label: 'Add Comments',
  showLabel: true,
  rows: 5,
};

export default CommentBox;
